import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import LoginPage from "./pages/LoginPage";
import Dashboard from "./pages/Dashboard"; // Create this later
import HomePage from "./pages/HomePage"; // Create this component
import { getCurrentUser } from "./auth/session";

const ProtectedRoute = ({ children }) => {
  const u = getCurrentUser();
  if (!u) return <Navigate to="/" replace />;
  return children;
};

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route path="/dashboard" element={<Dashboard />} />{" "}
        <Route
          path="/home"
          element={
            <ProtectedRoute>
              <HomePage />
            </ProtectedRoute>
          }
        />{" "}
        {/* Protect this route */}
      </Routes>
    </Router>
  );
};

export default App;
